import { makeAutoObservable } from 'mobx';

export default class SharedViewNavPresenter {
	constructor( {
		assets
	} ) {
		this.assets = assets;
		this.isShowingDownloadPopup = false;

		makeAutoObservable( this );
	}

	downloadAllAssetsWasClicked = () => {
		this.isShowingDownloadPopup = true;
	};

	downloadAllAssetsPopupWasClosed = () => {
		this.isShowingDownloadPopup = false;
	};
}
